import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { AccountListingStatus } from "@/types/serializers";

interface ListingStatusSelectProps {
  value: AccountListingStatus | "";
  onChange: (value: AccountListingStatus) => void;
}

export default function ListingStatusSelect({
  value,
  onChange,
}: ListingStatusSelectProps) {
  return (
    <div className="grid gap-2">
      <Label htmlFor="account-listing-status">
        Listing Status <span className="text-destructive">*</span>
      </Label>
      <Select
        value={value}
        onValueChange={(next) => onChange(next as AccountListingStatus)}
      >
        <SelectTrigger id="account-listing-status">
          <SelectValue placeholder="Select listing status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="listed">Public</SelectItem>
          <SelectItem value="unlisted">Private</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
